"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.otpProviders = exports.checksumAlgorithms = exports.ticketTypes = exports.fileCreators = void 0;
// Gender
const _genders = ['MALE', 'FEMALE', 'OTHER', 'NOT_SHARED'];
// File Creator
exports.fileCreators = ['SERVER', 'BOX', 'WORKER', 'AUTO_TRANSFORM'];
// Task Status
const _taskStatuses = ['DRAFT', 'PREVIEW', 'SUBMITTED', 'APPROVED', 'COMPLETED'];
// Ticket Type
exports.ticketTypes = ['TASK', 'BUG', 'NEW_FEATURE', 'IMPROVEMENT'];
// Microtask Status
/**
 * MANUALLY_EXPIRED: This status acts as a soft-delete for microtasks
 */
const _microtaskStatuses = ['INCOMPLETE', 'COMPLETED', 'MANUALLY_EXPIRED'];
// Task Op Type -- TODO: move to task op handlers
const _taskOpTypes = [
    'PROCESS_INPUT',
    'GENERATE_OUTPUT',
    'EXECUTE_FORWARD_TASK_LINK',
    'EXECUTE_BACKWARD_TASK_LINK',
    'HANDLE_ASSIGNMENT_COMPLETION',
    'HANDLE_VERIFIED_ASSIGNMENTS',
    'HANDLE_MICROTASK_COMPLETION',
    'EXECUTE_AUTO_TRANSFORM',
    'LINK_BY_PHONE',
    'LINK_BY_WORKER_ID',
];
// Task Op Status -- TODO: move to task op handlers
const _taskOpStatuses = ['CREATED', 'RUNNING', 'COMPLETED', 'FAILED'];
// Task Assignment Status
const _taskAssignmentStatuses = ['ASSIGNED', 'COMPLETED'];
// Microtask Assignment Status
const _microtaskAssignmentStatuses = [
    'ASSIGNED',
    'COMPLETED',
    'SUBMITTED', // State only present in client application
    'SKIPPED',
    'EXPIRED',
    'VERIFIED',
    'IGNORED',
    'MANUALLY_EXPIRED', // when a task owner expires an assignment manually before it is auto expired by the system
];
const _microtaskAssignmentBatchStatuses = ['UNALLOCATED', 'ALLOCATED', 'INVALIDATED'];
// Datapoint Status
const _datapointStatuses = [
    'ACTIVE',
    'MANUALLY_EXPIRED', // when a datapoint is soft-deleted/manually expired by the task owner
];
// Checksum Algorithm
exports.checksumAlgorithms = ['MD5'];
/** OTP SMS provider stored on `org_config.otp_provider`. */
exports.otpProviders = ['2FACTOR', 'AFRO', 'TWILIO'];
//# sourceMappingURL=CustomStrings.js.map